import { render, staticRenderFns } from "./OpportunityCoverImage.vue?vue&type=template&id=12695c78"
import script from "./OpportunityCoverImage.vue?vue&type=script&lang=js"
export * from "./OpportunityCoverImage.vue?vue&type=script&lang=js"
import style0 from "./OpportunityCoverImage.vue?vue&type=style&index=0&id=12695c78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports